<script>
import SnackBar from './components/SnackBar.vue'
export default {
  components: {
    SnackBar
  },
  created () {
    this.$store.commit('hideFeedback')
  }
  // created () {
  //   const APP_VERSION = process.env.VUE_APP_VERSION

  //   const savedVersion = localStorage.getItem('app_version')

  //   if (savedVersion !== APP_VERSION) {
  //     console.log('tessssssssssssst')
  //     localStorage.removeItem('TKtoken')
  //     localStorage.setItem('app_version', APP_VERSION)
  //   }
  // }
}
</script>

<template>
 <v-app>
    <snack-bar/>
    <router-view></router-view>
 </v-app>
</template>
